import { render, staticRenderFns } from "./view-dialog.vue?vue&type=template&id=38b0a853&scoped=true"
import script from "./view-dialog.vue?vue&type=script&lang=js"
export * from "./view-dialog.vue?vue&type=script&lang=js"
import style0 from "./view-dialog.vue?vue&type=style&index=0&id=38b0a853&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0a853",
  null
  
)

export default component.exports